<template>
  <div class="timer">
    {{ time | prettify }}
  </div>
</template>
<script>
export default {
  name: "Timer",
  data() {
    return {
      timeexam: 0,
    };
  },
  props: ["time"],
  filters: {
    prettify: function (value) {
      let hour = value[0];
      let minutes = value[1];
      let secondes = value[2];
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (secondes < 10) {
        secondes = "0" + secondes;
      }
      return minutes + ":" + secondes;
    },
  },
  methods: {},
  watch: {
    time() {},
  },
  mounted() {},
  beforeDestroy: function () {},
};
</script>
<style lang="scss" scoped>
</style>